import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { ModalComponent } from 'components/modal';

@Injectable()
export class ModalService {
    private modals: ModalComponent[] = [];

    add(modal: any) {
        this.modals.push(modal);
    }

    remove(modalId: string) {
        this.modals = _.without(this.modals, this.findModalById(modalId));
    }

    open(modalId: string) {
        this.findModalById(modalId).open();
    }

    close(modalId: string) {
        this.findModalById(modalId).close();
    }

    setData(modalId: string, data: any) {
        this.findModalById(modalId).setData(data);
    }

    getData(modalId: string) {
        return this.findModalById(modalId)?.data;
    }

    private findModalById(modalId: string) {
        return _.find(this.modals, { id: modalId });
    }
}
